class CustomSeries {

    constructor() {
        this.data = [];
        this.name = '';
        this.unit = 'Values';
        this.periodicity = 'A';
        this.visible = true;
    }

    sum(series) {
        this.periodicity = series[0].periodicity;
        this.name = this.getName(series, ' + ');
        this.data = this.getSum(series);
        this.unit = this.getUnit(series);
    }

    avg(series) {
        this.periodicity = series[0].periodicity;
        this.name = 'ø Average';
        this.data = this.getAvg(series);
        this.unit = this.getUnit(series);
    }

    min(series) {
        this.periodicity = series[0].periodicity;
        this.name = 'Min';
        this.data = this.getMin(series);
        this.unit = this.getUnit(series);
    }

    max(series) {
        this.periodicity = series[0].periodicity;
        this.name = 'Max';
        this.data = this.getMax(series);
        this.unit = this.getUnit(series);
    }

    getUnit(series) {
        let unit = _.uniq(series.map(function (item) {
            return item.unit;
        }));

        if (unit.length === 1) {
            return unit[0];
        } else {
            return 'Values';
        }
    }

    getSum(series) {
        let values = {};

        series.forEach(function (item) {
            item.data.forEach(function (point) {
                if (values[point.time] === undefined) {
                    values[point.time] = 0;
                }
                values[point.time] += point.value;
            })
        });

        let items = _.map(values, function(value, time) {
            return {
                time: time,
                value: value,
            };
        });

        return _.sortBy(items, 'time');
    }

    getAvg(series) {
        let items = _.map(this.getCombinedValues(series), function(values, time) {
            return {
                time: time,
                value: _.sum(values) / value.length,
            };
        });

        return _.sortBy(items, 'time');
    }

    getMin(series) {
        let items = _.map(this.getCombinedValues(series), function(values, time) {
            return {
                time: time,
                value: Math.min(values),
            };
        });

        return _.sortBy(items, 'time');
    }

    getMax(series) {
        let items = _.map(this.getCombinedValues(series), function(values, time) {
            return {
                time: time,
                value: Math.max(values),
            };
        });

        return _.sortBy(items, 'time');
    }

    getCombinedValues(series) {
        let values = {};

        series.forEach(function (item) {
            item.data.forEach(function (point) {
                if (values[point.time] === undefined) {
                    values[point.time] = [];
                }
                values[point.time].push(point.value);
            })
        });

        return values;
    }

    getName(series, separator) {
        return series.map(function (item) {
            return item.name;
        }).join(separator);
    }

    object() {
        return Object.freeze({
            data: this.data,
            unit: this.unit,
            visible: this.visible,
            periodicity: this.periodicity,
            name: this.name,
            modifiers: [],
            steps: [],
            range: {
                from: this.data[0].time,
                to: this.data[this.data.length - 1].time,
            }
        });
    }

}

export default CustomSeries;
